/**
 * Base dos trechos GLSL compartilhados (ADR 0007): os uniforms da atmosfera e o ruído barato. Escritos
 * para GLSL ES 3.0 (o Three compila todo ShaderMaterial como `#version 300 es`). Luz, neblina e o resto
 * ficam no registro de trechos (`chunks.ts`, F51).
 */
export const ATMOSPHERE_UNIFORMS = /* glsl */ `
uniform float uTime;
uniform vec3 uLightDir;
uniform vec3 uSunDir;
uniform vec3 uLightColor;
uniform vec3 uAmbientSky;
uniform vec3 uAmbientGround;
uniform vec3 uZenith;
uniform vec3 uHorizon;
uniform vec3 uFogColor;
uniform float uFogDensity;
uniform float uNight;
uniform float uSeaLevel;
`;

export const HASH = /* glsl */ `
float hash12(vec2 p) {
  vec3 p3 = fract(vec3(p.xyx) * 0.1031);
  p3 += dot(p3, p3.yzx + 33.33);
  return fract((p3.x + p3.y) * p3.z);
}
`;
